import React from "react";
import {
  CARD_TITLE_SIZE_CLASSES,
  TYPOGRAPHY_ROLE_CLASSES,
} from "@/utils/typographyTokens";

interface NoContentAvailableStateProps {
  currentLanguage: string;
  availableLanguages: string[];
}

const NoContentAvailableState: React.FC<NoContentAvailableStateProps> = ({
  currentLanguage,
  availableLanguages,
}) => {
  return (
    <div className="h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center max-w-md">
        <h2 className={`${CARD_TITLE_SIZE_CLASSES.lg} font-semibold text-gray-900 mb-2`}>
          No Content Available
        </h2>
        <p className={`${TYPOGRAPHY_ROLE_CLASSES.body} text-gray-600 mb-4`}>
          The published version exists but doesn't have content for the selected
          language ({currentLanguage}).
        </p>
        <p className={`${TYPOGRAPHY_ROLE_CLASSES.body} text-gray-500`}>
          Available languages: {availableLanguages.join(", ")}
        </p>
      </div>
    </div>
  );
};

export default NoContentAvailableState;
